import styled from 'styled-components';
import { compose, textAlign, TextAlignProps, width } from 'styled-system';

import { theme } from '../../../common/ui/theme';
import { TableBuilderColumnProps } from '../TableBuilderColumn';

export const StyledInlineHeaderCell = styled.th<TextAlignProps & Pick<TableBuilderColumnProps<unknown>, 'width'>>`
    padding: ${theme.space[8]};

    ${compose(textAlign, width)}
`;
